import React from 'react';

const Footer = () => {
  return (
    <footer>
      <h6>
        <i className='fab fa-connectdevelop'></i> devOcean
        <span> &copy; 2020 </span>
      </h6>
    </footer>
  );
};

export default Footer;
